<template>
    <section class="m-author-hero">
        <div class="m-author-hero__content">
            <div class="author-header">
                <img
                    src="@modules/blog/assets/author-title.png"
                    :alt="$t('blog.alt.icon')"
                    class="hero-header-icon"
                >
                <h2 class="author-header__title">
                    {{ publisher.name_full }}
                </h2>
            </div>
            <p class="author-biography">
                {{ publisher.biography }}
            </p>
        </div>
        <div class="m-author-hero__avatar">
            <img
                :src="imgSrc(publisher.avatar[0])"
                :alt="$t('blog.alt.icon')"
                class="author-avatar-img"
            >
        </div>
    </section>
</template>

<script >

    export default {
        name: 'BlogAuthorHero',

        /**
         *
         * @inheritDoc
         */
        props: {
            publisher: {
                type: Object,
            },
        },

    };

</script>

<style lang="scss" src="./author-hero.scss"/>
